import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const isFirebaseConfigured = () =>
  Boolean(
    firebaseConfig.apiKey &&
    firebaseConfig.authDomain &&
    firebaseConfig.projectId &&
    firebaseConfig.appId
  );

let app = null;
let auth = null;
let db = null;
export let googleProvider = null;

if (isFirebaseConfigured()) {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app, "mou-management");
  googleProvider = new GoogleAuthProvider();
  // Optional: prompt the user with the vnrvjiet.in domain
  // googleProvider.setCustomParameters({ hd: 'vnrvjiet.in' });
} else if (process.env.NODE_ENV === 'development') {
  console.warn(
    'Firebase is not configured. Add REACT_APP_FIREBASE_* variables to client/.env.development.local'
  );
}

export { app, auth, db };
